import * as types from './actionTypes';
import {ajaxCallError} from './ajaxStatusActions';
import {Api} from '../api/Api';
import {beginAjaxCall, sinReducerSuccess} from './ajaxStatusActions';


export function setIdioma(idioma) {
    //console.log(idioma);
	return {type: types.SET_IDIOMA, datos:idioma};
}
